import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { ArcLogo } from 'components/ArcLogo'
import { ARC_BORDER } from 'components/ArcAuthPage'

/** Values cloned from the arcmosaico.ai nav (main.css) */
const NAV_HEIGHT_PX = 70
const NAV_MAX_WIDTH_PX = 1180
const NAV_PADDING_PX = 28
const LOGO_HEIGHT_PX = 32

const Bar = styled.header`
  position: sticky;
  top: 0;
  z-index: 200;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(16px);
  border-bottom: 1px solid ${ARC_BORDER};
`

const Inner = styled.div`
  display: flex;
  align-items: center;
  height: ${NAV_HEIGHT_PX}px;
  max-width: ${NAV_MAX_WIDTH_PX}px;
  margin: 0 auto;
  padding: 0 ${NAV_PADDING_PX}px;
  width: 100%;

  a {
    display: inline-flex;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.8;
    }
  }
`

const SIGNIN_HOME_PATH = '/account/signin'

export const ArcAuthHeader = () => (
  <Bar>
    <Inner>
      <Link to={SIGNIN_HOME_PATH} aria-label='ArcMosaico'>
        <ArcLogo height={LOGO_HEIGHT_PX} />
      </Link>
    </Inner>
  </Bar>
)
